import { render, staticRenderFns } from "./FormQuiz.vue?vue&type=template&id=4f94e4ff&scoped=true&lang=pug"
import script from "./FormQuiz.vue?vue&type=script&lang=ts"
export * from "./FormQuiz.vue?vue&type=script&lang=ts"
import style0 from "./FormQuiz.vue?vue&type=style&index=0&id=4f94e4ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f94e4ff",
  null
  
)

export default component.exports